import React from "react";
import styles from "../styles";
import pfp from "../assets/pfp.jpg";

import dash1 from "../assets/circle-arrow-right-solid.svg";

const Hero = () => (
  <section
    id="home"
    className={`flex text-white gradient-05 w-full ${styles.paddingX} ${styles.paddingY}`}
  >
    <div className="flex flex-col sm:flex-row justify-between">
      <div className="flex flex-col justify-between items-center">
        <h1 className="text-[40px] sm:text-[60px] font-semibold text-start">
          Hey there! I'm <span className="text-gradient">Dhrumi Shah</span>
        </h1>
        <p className="text-slate-400 mt-4 lg:text-[18px] sm:text-[22px] leading-[28px] xs:leading-[33px] text-start ">
          I start and end my day with handling pixels on screen, yep! I am a
          Frontend Developer . I have a good grip on ReactJs and TailwindCSS . I
          have I tried out technologies like Three.js and Firebase.
          <br /> Well! I drink and build a lot 🥤🏗️
        </p>
        <div className="mt-12 flex flex-col-reverse lg:items-start sm:flex-row sm:items-center sm:gap-10">
          <a
            href="https://drive.google.com/file/d/1giHLrCB_LRqZ-2ohsifqbPTa91osDkz7/view?usp=sharing"
            target="_blank"
          >
            <button className=" mt-4 rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[100px] h-[40px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
              RESUME
            </button>
          </a>
          <a href="#contacts">
            <h2 className="text-gradient flex flex-row gap-4 items-center mt-4 font-semibold text-[34px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300">
              Let's Connect
              <img
                src={dash1}
                alt="arrow"
                className="w-[40px] h-[40px] mt-2 bg-white rounded-full"
              />
            </h2>
          </a>
        </div>
      </div>

      <img
        src={pfp}
        className="mx-auto w-[300px] sm:w-1/3 floatimg mt-8 sm:mt-0 object-contain rounded-[50%]"
      />
    </div>
  </section>
);

export default Hero;
